import React from "react";
import {
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  Row,
  Col,
  Typography,
  message,
} from "antd";
import { createInventoryApi } from "../../services/InventoryApi";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
// import { createInventoryApi } from "../services/inventory"; // your API file

const { Title } = Typography;
const { Option } = Select;

export default function CreateInventory() {
  const [form] = Form.useForm();
let {companyId} = useParams()
  const onFinish = async (values) => {
    try {
      let res = await createInventoryApi(companyId,values);
      if(!res?.sucess) return toast.error(res?.message||'something went wrong!')
        toast.success('Created sucessfully!')
      message.success("Inventory item created successfully!");
      form.resetFields();
    } catch (err) {
      console.error(err);
      message.error("Failed to create inventory item");
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      <Title level={3}>Create Inventory</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          measurement: "kg",
        }}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="productType"
              label="Product Type"
              rules={[{ required: true, message: "Please enter product type" }]}
            >
              <Input placeholder="e.g. Electronics" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="productName"
              label="Product Name"
              rules={[{ required: true, message: "Please enter product name" }]}
            >
              <Input placeholder="e.g. Washing Machine" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item name="productCode" label="Product Code (Optional)">
              <Input placeholder="e.g. WMX-1234" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="price"
              label="Price"
              rules={[{ required: true, message: "Please enter price" }]}
            >
              <InputNumber
                placeholder="e.g. 12000"
                min={0}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="measurement"
              label="Measurement Unit"
              rules={[{ required: true, message: "Select measurement unit" }]}
            >
              <Select>
                <Option value="cm">cm</Option>
                <Option value="kg">kg</Option>
                <Option value="g">g</Option>
                <Option value="L">L</Option>
                <Option value="ml">ml</Option>
                <Option value="m">m</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="unit"
              label="Unit"
              rules={[{ required: true, message: "Please enter unit count" }]}
            >
              <InputNumber
                placeholder="e.g. 10"
                min={1}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="qty"
              label="Quantity"
              rules={[{ required: true, message: "Please enter quantity" }]}
            >
              <InputNumber
                placeholder="e.g. 100"
                min={1}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="duration"
              label="Duration"
              rules={[{ required: true, message: "Please enter duration" }]}
            >
              <Input placeholder="e.g. 6 months" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create Inventory
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
